/**
 * A Listener Genie's phone number rings the business's own phones and records
 * the call for analysis. Mirrors supabase/functions/_shared/telephony/listener-phone.ts.
 */
export interface ListenerPhoneSettings {
  ring_to: string[];
  ring_seconds: number;
  disclosure_enabled: boolean;
  disclosure_text: string;
  voicemail_enabled: boolean;
}

export const LISTENER_PHONE_MODE = "listener";
export const MAX_LISTENER_RING_TO = 3;
export const MIN_LISTENER_RING_SECONDS = 10;
export const MAX_LISTENER_RING_SECONDS = 60;
export const MAX_LISTENER_DISCLOSURE_LENGTH = 300;

export const DEFAULT_LISTENER_PHONE_SETTINGS: ListenerPhoneSettings = {
  ring_to: [],
  ring_seconds: 25,
  disclosure_enabled: true,
  disclosure_text: "This call may be recorded for quality and training purposes.",
  voicemail_enabled: true,
};

export const resolveListenerPhoneSettings = (metadata: Record<string, unknown> | null | undefined): ListenerPhoneSettings => ({
  ...DEFAULT_LISTENER_PHONE_SETTINGS,
  ...((metadata?.listener as Partial<ListenerPhoneSettings> | undefined) ?? {}),
});
